import { creditAssessment } from "@wayke-se/ecom";
export default (caseId, callback) => {
    creditAssessment
        .accept(caseId)
        .then(callback)
        .catch(() => callback(false));
};
